import { onMounted, onBeforeUnmount } from 'vue';

export function useFadeUpObserver(selector = '.fade-up-animation') {
  let observer: IntersectionObserver | null = null;

  onMounted(() => {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-up-animation-visible');
            observer?.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -100px 0px' }
    );

    document.querySelectorAll(selector).forEach((el) => observer?.observe(el));
  });

  onBeforeUnmount(() => {
    observer?.disconnect();
  });
}
